import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EditApi from './Api/EditApi';
import { useMsal } from '@azure/msal-react';
import RecordingApi from './Api/RecordingApi';
import { TextField } from './Edit/TextField';
import { ErrorMessages } from './ErrorMessages';
import { RecordingSizeInput } from './Edit/RecordingSizeInput';
import { Loading } from './Loading';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { acquireAccessToken } from './msal/acquireAccessToken';


export function ReviewSuggestion() {
    const { id } = useParams();

    const { instance, accounts } = useMsal();

    const [suggestion, setSuggestion] = useState(null);
    const [recordingDetails, setRecordingDetails] = useState(null);
    const [sessionDetails, setSessionDetails] = useState(null);
    const [errors, setErrors] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);


    const submit = (approved) => {
        console.log(`suggestion ${id} approved = ${approved}`)
        
        setLoading(true);

        acquireAccessToken(instance, accounts).then(accessToken => {
            
            EditApi.updateSuggestionStatus(accessToken, id, approved).then((response) => {

                if (!response.ok) {
                    throw Error("An error occurred processing the approval / rejection")
                }

                setSubmitted(true)
                setLoading(false);
            }).catch(e => {
                setLoading(false);
                setErrors(["An error occurred processing the approval / rejection"])
            })
        }).catch(() => {
            setLoading(false);
            setErrors(["Please sign in again to continue."])
        });
    }

    const approve = () => { submit(true); };
    const reject = () => { submit(false); };

    useEffect(() => {

        setLoading(true);

        acquireAccessToken(instance, accounts).then(accessToken => {

            EditApi.getSuggestionById(accessToken, id).then((data) => {

                console.log("setRecordingEditCollection", data);
                setLoading(false);
                setSuggestion(data);
            });
        }).catch(() => {
            setLoading(false);
            setErrors(["Please sign in again to continue."])
        });
    }, [id, accounts, instance]);


    useEffect(() => {

        if (suggestion?.recordingId != null)
        {
            RecordingApi.getRecording(suggestion?.recordingId).then(response => {
                if (!response.ok)
                {
                    throw Error("Error loading recording")
                }
    
                return response.json()
            }).then((data) => {
    
                console.log("setRecordingEditCollection", data);
                setRecordingDetails(data);
            })
            .catch(e => {
                setErrors({ "general": ["An error occured. Please try again later."] });
                setLoading(false);
            });
        }

    }, [suggestion]);

    useEffect(() => {

        if (suggestion?.sessionId != null && suggestion?.suggestionType === "edit_session")
        {
            RecordingApi.getSession(suggestion?.sessionId).then(response => {
                if (!response.ok)
                {
                    throw Error("Error loading session")
                }
    
                return response.json()
            }).then((data) => {
    
                console.log("setSessionDetails", data);
                setSessionDetails(data);
            })
            .catch(e => {
                setErrors({ "general": ["An error occured. Please try again later."] });
                setLoading(false);
            });
        }

    }, [suggestion]);


    if (loading) {
        return (<Loading display={loading} />)
    }

    if (submitted) {
        return (
            <>
                <h1 className="title is-spaced">Suggestion Review Complete</h1>


                <NavLink to="/review">View other suggestions</NavLink>
            </>
        );
    }

    if (errors) {
        return (
            <ErrorMessages errors={Object.values(errors ?? {}).flat()} />
        )
    }

    if (suggestion === null) {
        return null;
    }

    if (suggestion?.recordingId != null && recordingDetails === null) {
        return (<Loading display={true} />)
    }

    if (suggestion?.suggestionType === "edit_session" && sessionDetails === null) {
        return (<Loading display={true} />)
    }

    if (suggestion.suggestionType === "delete_recording") {
        return (<ReviewDeleteRecording recordingDetails={recordingDetails} suggestion={suggestion} approve={approve} reject={reject} />)
    }
    else if (suggestion.suggestionType === "move_recording") {
        return (<ReviewMoveRecording recordingDetails={recordingDetails} suggestion={suggestion} approve={approve} reject={reject} />)
    }
    else if (suggestion.suggestionType === "move_recording_new") {
        return (<ReviewMoveRecordingNewSession recordingDetails={recordingDetails} suggestion={suggestion} approve={approve} reject={reject} />)
    }    
    else if (suggestion.suggestionType === "add_recording") {
        return (<ReviewAddRecording suggestion={suggestion} approve={approve} reject={reject} />)
    }
    else if (suggestion.suggestionType === "edit_recording") {
        return (<ReviewEditRecording recordingDetails={recordingDetails} suggestion={suggestion} approve={approve} reject={reject} />)
    }
    else if (suggestion.suggestionType === "edit_session") {
        return (<ReviewEditSession sessionDetails={sessionDetails} suggestion={suggestion} approve={approve} reject={reject} />)
    }

    return null;

}

function IssuesFromRecordingDetails(recording) {
    let issues = recording?.issues?.map(i => i.issueNumber).filter(t => t != null && t !== '') ?? [];

    if (issues.length < 1) {
        issues.push('');
    }

    return issues;
}

function TitlesFromRecordingDetails(recording) {
    let titles = [recording?.title ?? '', recording?.title1 ?? '', recording?.title2 ?? '', recording?.title3 ?? '', recording?.title4 ?? '', recording?.title5 ?? ''].filter(t => t != null && t !== '');

    if (titles.length < 1) {
        titles.push('');
    }

    return titles;
}

function ReviewAddRecording({suggestion, approve, reject}) {

    let issues = [suggestion.issue1, suggestion.issue2, suggestion.issue3, suggestion.issue4, suggestion.issue5].filter(i => i != null && i !== '');

    return (
        <>
        <h1 className="title is-spaced">Add Recording Suggestion</h1>

        <RecordingFields recording={suggestion} issues={issues} />

        <TextField
            label="Destination Session Id"
            name="Destination Session Id"
            value={suggestion?.sessionId}
            disabled={true}
            />

        <SuggestionFields suggestion={suggestion} />

        <RejectApproveButtons reject={reject} approve={approve} />

        </>
    );

}

function ReviewMoveRecording({recordingDetails, suggestion, approve, reject}) {

    return (
        <>
        <h1 className="title is-spaced">Move Recording to Another Session Suggestion</h1>

        <RecordingFields recording={recordingDetails?.recording} />

        <TextField
            label="Destination Session Id"
            name="Destination Session Id"
            value={suggestion?.sessionId}
            disabled={true}
            />

        <RejectApproveButtons reject={reject} approve={approve} />

        </>
    );
}

function ReviewMoveRecordingNewSession({recordingDetails, suggestion, approve, reject}) {

    return (
        <>
        <h1 className="title is-spaced">Move Recording to Another Session Suggestion</h1>

        <RecordingFields recording={recordingDetails?.recording} />
   
        <TextField
            label="Session Notes"
            name="session-notes"
            value={suggestion?.sessionNotes}
            disabled={true}
            />

        <TextField
            label="Artist 1"
            name="artist-1"
            value={suggestion?.artist1}
            disabled={true}
            />
        
        <TextField
            label="Artist 2"
            name="artist-2"
            value={suggestion?.artist2}
            disabled={true}
            />

        <TextField
            label="Artist 3"
            name="artist-3"
            value={suggestion?.artist3}
            disabled={true}
            />
        
        <TextField
            label="Artist 4"
            name="artist-4"
            value={suggestion?.artist4}
            disabled={true}
            />

        <TextField
            label="Artist 5"
            name="artist-5"
            value={suggestion?.artist5}
            disabled={true}
            />

        <TextField
            label="Destination Session Group Id"
            name="Destination Session Group Id"
            value={suggestion?.sessionGroupId}
            disabled={true}
            />

        {suggestion?.sessionGroupNotes && (
        <TextField
            label="New Session Group Notes"
            name="New Session Group Notes"
            value={suggestion?.sessionGroupNotes}
            disabled={true}
            />
        )}


        {suggestion?.locationId && (
        <TextField
            label="New Session Group Location Id"
            name="New Session Group Location Id"
            value={suggestion?.locationId}
            disabled={true}
            />
        )}

        {suggestion?.sessionGroupId === null && suggestion?.locationId === null && (
        <>
        <TextField
            label="Venue"
            name="venue"
            value={suggestion?.newLocationVenue}
            disabled={true}
            />
        
        
        <TextField
            label="City"
            name="city"
            value={suggestion?.newLocationCity}
            disabled={true}
            />
        
        <TextField
            label="City"
            name="city"
            value={suggestion?.newLocationCountry}
            disabled={true}
            />

        </>
        )}

        <SuggestionFields suggestion={suggestion} />

        <RejectApproveButtons reject={reject} approve={approve} />

        </>
    );
}

function ReviewEditRecording({recordingDetails, suggestion, approve, reject}) {

        let issues = [suggestion.issue1, suggestion.issue2, suggestion.issue3, suggestion.issue4, suggestion.issue5].filter(i => i != null && i !== '');
                   
        return (
            <>
            <h1 className="title is-spaced">Edit Recording Suggestion</h1>
    
            <RecordingComparisonFields originalRecording={recordingDetails?.recording} suggestedRecording={suggestion} suggestedIssues={issues} />
    
            <SuggestionFields suggestion={suggestion} />
    
            <RejectApproveButtons reject={reject} approve={approve} />
    
            </>
        );
}

function ReviewEditSession({sessionDetails, suggestion, approve, reject}) {

    return (
        <>
        <h1 className="title is-spaced">Edit Session Suggestion</h1>

        <SessionComparisonFields sessionDetails={sessionDetails} suggestion={suggestion} />

        <SuggestionFields suggestion={suggestion} />

        <RejectApproveButtons reject={reject} approve={approve} />

        </>
    );
}

function SessionComparisonFields({sessionDetails, suggestion}) {
    let rows = SessionComparisonRows(sessionDetails, suggestion);

    return (
        <div className="block">
            <div className="columns">
                <div className="column is-6 review-comparison-column">
                    <h2 className="subtitle">Current Values</h2>
                    <SessionComparisonColumn rows={rows} column="current" />
                </div>

                <div className="column is-6 review-comparison-column">
                    <h2 className="subtitle">Suggested Values</h2>
                    <SessionComparisonColumn rows={rows} column="suggested" />
                </div>
            </div>
        </div>
    )
}

function SessionComparisonColumn({rows, column}) {
    return (
        <>
        {rows.map((row, index) => {
            if (row.section) {
                return (
                    <h3 key={`${column}-${row.section}-${index}`} className="review-comparison-section-title">
                        {row.section}
                    </h3>
                );
            }

            return (
                <SessionComparisonField
                    key={`${column}-${row.label}-${index}`}
                    label={row.label}
                    currentValue={row.currentValue}
                    suggestedValue={row.suggestedValue}
                    column={column}
                />
            );
        })}
        </>
    )
}

function SessionComparisonField({label, currentValue, suggestedValue, column}) {
    let changedClassName = ValuesAreDifferent(currentValue, suggestedValue) ? "review-changed-field" : "";
    let value = column === "current" ? currentValue : suggestedValue;

    return (
        <div className={changedClassName}>
            <TextField disabled={true} label={label} value={DisplayComparisonValue(value)} />
        </div>
    );
}

function SessionComparisonRows(sessionDetails, suggestion) {
    let session = sessionDetails?.session;
    let sessionGroup = sessionDetails?.sessionGroup;
    let location = sessionDetails?.location;
    let sessionGroupEditType = suggestion?.sessionGroupEditType ?? "current";
    let locationEditType = suggestion?.locationEditType ?? "current";

    let currentArtists = session?.artists ?? [];
    let suggestedArtistValues = [
        suggestion?.artist1,
        suggestion?.artist2,
        suggestion?.artist3,
        suggestion?.artist4,
        suggestion?.artist5
    ];
    let artistsWereSubmitted = suggestedArtistValues.some(a => a != null);
    let lastSuggestedArtistIndex = artistsWereSubmitted
        ? suggestedArtistValues.reduce((lastIndex, value, index) => value != null ? index : lastIndex, -1)
        : currentArtists.length - 1;
    let artistCount = Math.max(currentArtists.length, lastSuggestedArtistIndex + 1, 1);
    let suggestedArtists = artistsWereSubmitted ? suggestedArtistValues : currentArtists;

    let suggestedSessionGroupId = SuggestedValue(suggestion?.sessionGroupId, sessionGroup?.id);
    let suggestedSessionGroupNotes = SuggestedValue(suggestion?.sessionGroupNotes, sessionGroup?.notes);
    let suggestedFileId = SuggestedValue(suggestion?.fileId, sessionGroup?.fileId);

    if (sessionGroupEditType === "new") {
        suggestedSessionGroupId = "(new)";
    }
    else if (sessionGroupEditType === "existing") {
        suggestedSessionGroupNotes = "(from destination session group)";
        suggestedFileId = "(from destination session group)";
    }

    let suggestedLocationId = SuggestedValue(suggestion?.locationId, location?.id);
    let suggestedLocationVenue = SuggestedValue(suggestion?.locationVenue, location?.venue);
    let suggestedLocationCity = SuggestedValue(suggestion?.locationCity, location?.city);
    let suggestedLocationCountry = SuggestedValue(suggestion?.locationCountry, location?.country);

    if (sessionGroupEditType === "existing") {
        suggestedLocationId = "(from destination session group)";
        suggestedLocationVenue = "(from destination session group)";
        suggestedLocationCity = "(from destination session group)";
        suggestedLocationCountry = "(from destination session group)";
    }
    else if (locationEditType === "new") {
        suggestedLocationId = "(new)";
    }
    else if (locationEditType === "existing") {
        suggestedLocationVenue = "(from destination location)";
        suggestedLocationCity = "(from destination location)";
        suggestedLocationCountry = "(from destination location)";
    }

    let rows = [
        { section: "Session" },
        ComparisonRow("Session Id", session?.id, SuggestedValue(suggestion?.sessionId, session?.id)),
        ComparisonRow("Session Notes", session?.notes, SuggestedValue(suggestion?.sessionNotes, session?.notes))
    ];

    for (let index = 0; index < artistCount; index++) {
        rows.push(ComparisonRow(`Artist ${index + 1}`, currentArtists[index], suggestedArtists[index]));
    }

    rows.push(
        { section: "Session Group" },
        ComparisonRow("Session Group Action", SessionGroupModeLabel("current"), SessionGroupModeLabel(sessionGroupEditType)),
        ComparisonRow("Session Group Id", sessionGroup?.id, suggestedSessionGroupId),
        ComparisonRow("Session Group Notes", sessionGroup?.notes, suggestedSessionGroupNotes),
        ComparisonRow("File Id", sessionGroup?.fileId, suggestedFileId),
        { section: "Location" },
        ComparisonRow("Location Action", LocationModeLabel("current"), sessionGroupEditType === "existing" ? "(from destination session group)" : LocationModeLabel(locationEditType)),
        ComparisonRow("Location Id", location?.id, suggestedLocationId),
        ComparisonRow("Venue", location?.venue, suggestedLocationVenue),
        ComparisonRow("City", location?.city, suggestedLocationCity),
        ComparisonRow("Country", location?.country, suggestedLocationCountry)
    );

    return rows;
}

function ComparisonRow(label, currentValue, suggestedValue) {
    return { label, currentValue, suggestedValue };
}

function SessionGroupModeLabel(value) {
    if (value === "new") {
        return "Move to new session group";
    }

    if (value === "existing") {
        return "Move to existing session group";
    }

    return "Current session group";
}

function LocationModeLabel(value) {
    if (value === "new") {
        return "New location";
    }

    if (value === "existing") {
        return "Existing location";
    }

    return "Current location";
}

function DisplayComparisonValue(value) {
    if (value == null || value === "") {
        return "(blank)";
    }

    return String(value);
}

function SuggestedValue(suggestedValue, currentValue) {
    return suggestedValue == null ? currentValue : suggestedValue;
}

function RecordingComparisonFields({originalRecording, suggestedRecording, suggestedIssues}) {

    let originalIssues = IssuesFromRecordingDetails(originalRecording);
    let suggestedIssueValues = [
        suggestedRecording?.issue1,
        suggestedRecording?.issue2,
        suggestedRecording?.issue3,
        suggestedRecording?.issue4,
        suggestedRecording?.issue5
    ];

    let issueCount = Math.max(originalIssues.length, suggestedIssues.length, 1);

    return (
        <>
        <div className="block">
            <div className="columns">

                <div className="column is-6">
                    <h2 className="subtitle">Current Values</h2>

                    <ComparisonField label="Matrix Number" currentValue={originalRecording?.matrixNumber} suggestedValue={suggestedRecording?.matrixNumber} column="current" />

                    <ComparisonField label="Prefix" currentValue={originalRecording?.prefix} suggestedValue={suggestedRecording?.prefix} column="current" />

                    <ComparisonField label="Suffix" currentValue={originalRecording?.suffix} suggestedValue={suggestedRecording?.suffix} column="current" />

                    <ComparisonField label="Take Number" currentValue={originalRecording?.takeNumber} suggestedValue={suggestedRecording?.takeNumber} column="current" />

                    <ComparisonField label="Recording Date" currentValue={originalRecording?.recordingDate} suggestedValue={suggestedRecording?.recordingDate} column="current" />

                    <ComparisonField label="Extra Data" currentValue={originalRecording?.extraData} suggestedValue={suggestedRecording?.extraData} column="current" />

                    <ComparisonField label="Size" currentValue={originalRecording?.sizeCode} suggestedValue={suggestedRecording?.sizeCode} column="current" type="size" />

                    <ComparisonField label="Notes" currentValue={originalRecording?.notes} suggestedValue={suggestedRecording?.notes} column="current" />
                </div>

                <div className="column is-6">
                    <h2 className="subtitle">Suggested Values</h2>

                    <ComparisonField label="Matrix Number" currentValue={originalRecording?.matrixNumber} suggestedValue={suggestedRecording?.matrixNumber} column="suggested" />

                    <ComparisonField label="Prefix" currentValue={originalRecording?.prefix} suggestedValue={suggestedRecording?.prefix} column="suggested" />

                    <ComparisonField label="Suffix" currentValue={originalRecording?.suffix} suggestedValue={suggestedRecording?.suffix} column="suggested" />

                    <ComparisonField label="Take Number" currentValue={originalRecording?.takeNumber} suggestedValue={suggestedRecording?.takeNumber} column="suggested" />

                    <ComparisonField label="Recording Date" currentValue={originalRecording?.recordingDate} suggestedValue={suggestedRecording?.recordingDate} column="suggested" />

                    <ComparisonField label="Extra Data" currentValue={originalRecording?.extraData} suggestedValue={suggestedRecording?.extraData} column="suggested" />

                    <ComparisonField label="Size" currentValue={originalRecording?.sizeCode} suggestedValue={suggestedRecording?.sizeCode} column="suggested" type="size" />

                    <ComparisonField label="Notes" currentValue={originalRecording?.notes} suggestedValue={suggestedRecording?.notes} column="suggested" />
                </div>
            </div>
        </div>

        <ComparisonTextFields
            label="Title"
            currentValues={[
                originalRecording?.title,
                originalRecording?.title2,
                originalRecording?.title3,
                originalRecording?.title4,
                originalRecording?.title5
            ]}
            suggestedValues={[
                suggestedRecording?.title1,
                suggestedRecording?.title2,
                suggestedRecording?.title3,
                suggestedRecording?.title4,
                suggestedRecording?.title5
            ]}
            count={5}
        />

        <ComparisonTextFields
            label="Issue"
            currentValues={originalIssues}
            suggestedValues={suggestedIssueValues}
            count={issueCount}
        />
        </>
    )
}

function ComparisonTextFields({label, currentValues, suggestedValues, count}) {
    let fields = Array.from({ length: count }, (_, index) => index);

    return (
        <div className="block">
            <div className="columns">
                <div className="column is-6">
                    {fields.map((index) => {
                        return (<ComparisonField
                            key={`original-${label}-${index}`}
                            label={`${label} ${index + 1}`}
                            currentValue={currentValues[index]}
                            suggestedValue={suggestedValues[index]}
                            column="current"
                        />);
                    })}
                </div>

                <div className="column is-6">
                    {fields.map((index) => {
                        return (<ComparisonField
                            key={`suggested-${label}-${index}`}
                            label={`${label} ${index + 1}`}
                            currentValue={currentValues[index]}
                            suggestedValue={suggestedValues[index]}
                            column="suggested"
                        />);
                    })}
                </div>
            </div>
        </div>
    )
}

function ComparisonField({label, currentValue, suggestedValue, column, type}) {
    let changedClassName = ValuesAreDifferent(currentValue, suggestedValue) ? "review-changed-field" : "";
    let value = column === "current" ? currentValue : suggestedValue;

    return (
        <div className={changedClassName}>
            {type === "size" ? (
                <RecordingSizeInput disabled={true} value={value} />
            ) : (
                <TextField disabled={true} label={label} value={value} />
            )}
        </div>
    );
}

function ValuesAreDifferent(currentValue, suggestedValue) {
    return NormalizeComparisonValue(currentValue) !== NormalizeComparisonValue(suggestedValue);
}

function NormalizeComparisonValue(value) {
    if (value == null) {
        return "";
    }

    return String(value).trim();
}

function ReviewDeleteRecording({recordingDetails, suggestion, approve, reject}) {
           
    return (
        <>
        <h1 className="title is-spaced">Delete Recording Suggestion</h1>

        <RecordingFields recording={recordingDetails?.recording} />

        <SuggestionFields suggestion={suggestion} />

        <RejectApproveButtons reject={reject} approve={approve} />

        </>
    );
}

function SuggestionFields({suggestion}) {
    return (
        <>
        <TextField label="Suggestion Author" value={suggestion.emailAddress} disabled={true} />

        <TextField label="Reason for Change" value={suggestion.suggestionNotes} disabled={true} />
        </>
    )

}

function RecordingFields({recording, titles, issues}) {

    titles = titles ?? TitlesFromRecordingDetails(recording)
    issues = issues ?? IssuesFromRecordingDetails(recording)

    return (
        <>
        <div className="block">
            <div className="columns">

                <div className="column is-6">
                    <TextField disabled={true} label="Matrix Number" value={recording?.matrixNumber} />

                    <TextField disabled={true} label="Prefix" value={recording?.prefix} />

                    <TextField disabled={true} label="Suffix" value={recording?.suffix} />
                </div>

                <div className="column is-6">
                    <TextField disabled={true} label="Take Number" value={recording?.takeNumber} />

                    <TextField disabled={true} label="Recording Date" value={recording?.recordingDate} />

                    <RecordingSizeInput disabled={true} value={recording?.sizeCode} />

                </div>
            </div>
        </div>

        <div className="block">
            <div className="columns">
                <div className="column is-12">

                    {titles.map((title, index) => {
                        return (<TextField
                            disabled={true} 
                            label={"Title " + (index + 1)}
                            name={"title[" + index + "]"}
                            value={titles[index]}
                        />);
                    })}
                </div>
            </div>
        </div>

        <div className="block">
            <div className="columns">
                <div className="column is-12">

                    {issues.map((issue, index) => {
                        return (<TextField
                            disabled={true} 
                            label={"Issue " + (index + 1)}
                            name={"issues[" + index + "]"}
                            value={issues[index]}
                        />);
                    })}
                </div>
            </div>
        </div>
        </>
    )
}

function RejectApproveButtons({reject, approve}) {

    return (
        <div className="field is-grouped">
            <div className="control">
                <button className="button is-danger is-outlined" onClick={(event) => { reject(); }}>
                    Reject Suggestion
                </button>
            </div>
            <div className="control">
                <button className="button is-success is-outlined" onClick={(event) => { approve(); }}>
                    Approve Suggestion
                </button>
            </div>
        </div>
    )
}
